// extracted by mini-css-extract-plugin
export var legendIndicator = "_au-1";
export var legendRight = "_au-0";